




















































// This component fetches a list of stories and displays them as a list of StoryComponent's
import { Component, Prop, Vue } from 'vue-property-decorator';
import { StoryUser } from '../StoryUser'
import { Circle } from '../Circle'
import { Story, statusType, privacyType } from '../Story'
import * as utils from '../utils';
import * as utils_time from '../utils_time';
import * as utils_auth from '../utils_auth';
import { globalUC } from '../UserCache'
import AvatarComponent from '@/components/AvatarComponent.vue';           // @ is an alias to /src
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'UserComponent',
  components: { AvatarComponent, ModalWrapperComponent }
})
export default class UserComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public startingUser: StoryUser

  @Prop({ default: null })
  public uid: string

  // public reactive member variables available to the html template
  public targetUser: StoryUser = this.startingUser

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading; }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get isAuthenticated(): StoryUser { return this.$store.getters.isAuthenticated }
  public get isMe(): boolean { return this.userId === this.uid }

  public computeAvatarSize(): number {
    if (window.innerWidth < 350) return 64
    if (window.innerWidth < 992) return 96
    return 128
  }

  public inThisCircle(): boolean {
    if (!this.targetUser) return false
    if (!this.isAuthenticated) return false
    return (this.targetUser.getCircle().isFollowedBy(this.userId) || this.user.isFollowing(this.targetUser.circleId))
  }
  public pendingCircle(): boolean {
    if (!this.targetUser) return false
    if (!this.isAuthenticated) return false
    return (this.user.pendingOutgoingFollowing.includes(this.targetUser.circleId) || this.targetUser.getCircle().isPendingIncomingFollower(this.userId))
  }

  public prettyTimeAgo(d: Date): string {
    if (!d) return ''
    // return utils_time.prettyTimeAgo(new Date().getTime() - d.getTime())
    return utils_time.timeAgo.format(d.getTime())
  }

  public prettyPhone(phone: string): string {
    if (!phone) return ''
    return utils.prettyE164toUS(phone)
  }

  public viewCircle(): void {
    const enableInviting: boolean = this.targetUser.getCircle().canManage(this.userId);
    // TODO: modify InvitesFormModalComponent to account for a manager inviting folks to someone else's circle
    //  As of now, we the circle.managers is always empty, so this is not a big deal yet that InvitesFormModalComponent doesn't support it.
    (this.$refs.UserCircleModalComponent as ModalWrapperComponent).show(`${this.targetUser.firstName}'s Listening Circle`, 'sm', { startingUid: this.targetUser.getIdAsString(), startingUser: this.targetUser, enableInviting } )
  }

  public async circleRequest() {
    // make POST call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + `/api/circles/${this.targetUser.circleId}/requestEntry`;
      const response: any = await utils.makePutCall(url, {} );
      if (!response || !response.data) throw(new Error('UserComponent.circleRequest() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.circle && response.data.user) {
        const me: StoryUser = new StoryUser(response.data.user)
        if (me.following.includes(this.targetUser.circleId)) {
          utils.toast(this, 'Success', `You are now in ${this.targetUser.firstName}'s listening circle.`)
        } else if (me.pendingOutgoingFollowing.includes(this.targetUser.circleId)) {
          utils.toast(this, 'Success', `Your request has been sent to ${this.targetUser.firstName}.`)
        } else {
          utils.toast(this, 'Failure', `Your request failed.`)
        }

        // take response.data.circle and update that user in the cache with their latest circle
        const updatedCircle: Circle = new Circle(response.data.circle)
        const updatedFriend: StoryUser = await globalUC.get(updatedCircle.storyTellerId, false)
        updatedFriend._temp.circle = updatedCircle
        globalUC.add(updatedFriend)

        // might as well update our user cache
        me.updateMeToCacheStoreAndLocalStorage()

      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not invite')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    await this.fetchData()

    // if (this.$store.state.devmode) console.dir(this.u)
  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

  private async fetchData(): Promise<void> {

    this.$store.commit('setLoading', { loading: true });
    try {
      // fetch user first if we need to
      if (!this.targetUser) {
        this.targetUser = await globalUC.get(this.uid, true)
        // if (this.$store.state.devmode) utils.toast(this, 'DEBUGGING', `Loaded user ${this.uid} from server`)
      }
    } catch (error) {
      utils.toast(this, 'Error', 'Could not load user')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }
  }

}
